export default __webpack_public_path__ + "static/media/notverified.61782b4b.svg";